import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

// If birthday is -2-29 -> -2-28
function shiftLeapBirthday(dob: string): string {
  return dayjs(dob).subtract(1, 'day').format('YYYY-MM-DD')
}

// If birthday is 1990-02-28 -> [current-year]-02-28
function birthdayToCurrentYear(dob: string | Date): Date {
  const currentYear = dayjs().year()
  return dayjs(dob).set('year', currentYear).toDate()
}

export const isLeapDob = (dob: string): boolean => {
  const leapDate = /(?:^|\W)02-29(?:$|\W)/g
  return leapDate.test(dob)
}

function normalizeBirthDate(dob: string): Date {
  const normalizedBirthDate = isLeapDob(dob)
    ? birthdayToCurrentYear(shiftLeapBirthday(dob))
    : birthdayToCurrentYear(dob)
  return normalizedBirthDate
}

function isBirthdayWeek(dob: string): boolean {
  const birthdayWeekRange = 3
  const currentDate = dayjs().format('YYYY-MM-DD')
  const normalizedBirthDate = normalizeBirthDate(dob)
  const diff = Math.abs(
    dayjs(currentDate).diff(normalizedBirthDate, 'day', true),
  )
  return Math.round(diff) <= birthdayWeekRange
}

export {
  shiftLeapBirthday,
  birthdayToCurrentYear,
  normalizeBirthDate,
  isBirthdayWeek,
}
